/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
saikrishna 11/25/2022  3031450488 Added BasicInfo new Ui fields
Gummala Prakash 11/28/2022 3031450488 Removed card component.
Rohini 12/05/2022 3031450488  changed side nav format.
Ashraf 12/05/2022 3031450488 Fixed header labels
Raghu 12/05/2022 3031450488 Card spacing fixes
Suresh Peddavoora 12/26/2022 3031450488 Fixed Tab Active Header Issue
Phanee 08/03/2023 3031450488 Fixed dashboard data disable issue
*/
import React, {useContext, useState} from 'react';
import LandingPage from '../../../Pages/LandingPage';
import {ThemeContext} from '../../../themes/ThemeProvider';
import SearchRuleGroup from '../ReportMaster/SearchReportMaster';
import AddReport from './AddReport/index';
const Reports = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [tabValue, setTabValue] = useState(0);
  const reportsHeading = ['Reporting/Export'];
  const [openTemplate, setOpenTemplate] = useState(false);
  const [copy, setCopy] = useState();
  const [reportCode, setReportCode] = useState(null);
  const [editExisting, setEditExisting] = useState('');
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={0}
        handleTabChange={()=>{}}
        allAntTabs={reportsHeading}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {tabValue === 0 && (
                  <SearchRuleGroup
                    setTabValue={setTabValue}
                    openTemplate={openTemplate}
                    setOpenTemplate={setOpenTemplate}
                    setCopy={setCopy}
                    copy={copy}
                    reportCode={reportCode}
                    setReportCode={setReportCode}
                    setEditExisting={setEditExisting}
                  />
                )}
                {tabValue === 1 && (
                  <AddReport setTabValue={setTabValue} editExisting={editExisting} />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};
export default Reports;
